export const products = [
  {
    id: 1,
    key: 'OSAGO',
    slug: 'osago',
    label: 'ОСЦПВ',
  },
  {
    id: 2,
    key: 'BUS_INSURANCE',
    slug: 'bus_insurance',
    label: '',
  },
  {
    id: 3,
    key: 'GREEN_CARD',
    slug: 'green_card',
    label: 'ЗК',
  },
  {
    id: 4,
    key: 'DGO',
    slug: 'dgo',
    label: 'ДЦВ',
  },
  {
    id: 5,
    key: 'TURISM',
    slug: 'tourism',
    label: 'Туризм',
  },
  {
    id: 6,
    key: 'AUTO_LAWYER',
    slug: 'autolawyer',
    label: 'Автоюрист',
  },
  {
    id: 7,
    key: 'MANUAL',
    slug: 'manual',
    label: 'Зовнішні замовлення',
  },
  {
    id: 8,
    key: 'HOME',
    slug: 'home',
    label: 'Страхування житла',
  },
  {
    id: 9,
    key: 'MINIKASKO',
    slug: 'miniKasko',
    label: 'МініКаско',
  },
  {
    id: 10,
    key: 'PETS',
    slug: 'pets',
    label: 'Страхування тварин',
  },
];

export const productIds = Object.fromEntries(
  products.map(({ key, id }) => [key, id])
);
